export default [
  {
      path: '/deployment-releases',
      component: () => import('../pages/deployments/Index.vue'),
      children: [
        {
            path: ':id',
            name: 'deployment-releases/detail',
            meta: {
                parentPath: '/deployments',
                layout: 'default',
                breadcrumb: [{ label: 'Deployments' }],
            },
            component: () => import('../pages/deployment-releases/DeploymentReleaseDetail.vue'),
        }
      ],
  },
];
